import { getLongDate } from 'services/functions';
import { translate } from 'react-i18next';

// Styles
import { AppointmentsPageHeader } from '../styles';

// Components
import StatusFilter from './StatusFilter/StatusFilter';
import FiltersSection from './FiltersSection/FiltersSection';

export default translate()(({ i18n }) => (
  <AppointmentsPageHeader>
    <div className="caption">
      <p className="name">{i18n.t('today')}</p>
      <p className="date">{getLongDate(i18n)}</p>
    </div>
    <div className="filter">
      <FiltersSection />
      <StatusFilter />
    </div>
  </AppointmentsPageHeader>
));
